<template>
  <div class="projectUpdatePlanView-all-box clearfix">
    <card>
      <div class="top-info">
        <div>
          {{$t("formData.companyName")}}：
          <span>{{formData.companyName}}</span>
        </div>
        <div>
          {{$t("formData.projectName")}}：
          <span>{{formData.peojectName}}</span>
        </div>
        <div>
          {{$t("formData.projectDevelopmentStatus")}}：
          <span>{{formData.developmentStatusName}}</span>
        </div>
      </div>

      <div class="down-content-box">
        <div class="line-box title-box clearfix">
          <div class="title"></div>
          <div class="hint">{{$t("formData.estimatedStartDate")}}</div>
          <div class="hint">{{$t("formData.estimatedEndDate")}}</div>
        </div>
        <div v-for="(item, index) in formData.phases" :key="index" class="line-box clearfix">
          <el-tooltip class="item" effect="dark" :content="item.stageName" placement="top">
            <div class="list-title">{{ item.stageName }}：</div>
          </el-tooltip>

          <el-date-picker
            :key="index + datePickerKey"
            :readonly="isView"
            v-model="item.timeRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator=" ~ "
            :clearable="false"
            :default-value="item.defaultValue"
            @change="planDateChange(item, index)"
          />
        </div>
      </div>

      <div class="btn-list-box input-form-btn-list">
        <cus-btn type="cancel" @click="cancel"></cus-btn>
        <cus-btn v-if="isView==false" type="save" :loading="saveLoding" @click="save()"></cus-btn>
      </div>
    </card>
  </div>
</template>

<script>
import {
  projectProcessLatestPlan,
  projectProcessUpdatePlan,
  projectProcessLatestIsApproved
} from "@/api/projectManagement";
export default {
  name: "ProjectUpdatePlanView",
  components: {},
  props: {
    isReturn: {
      type: Boolean,
      default: true
    },
    isView: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datePickerKey: 0,
      saveLoding: false,
      formData: {
        companyName: "",
        developmentStatusName: "",
        peojectName: "",
        projectId: "",
        processId: "",
        phases: []
      }
    };
  },
  created() {
    projectProcessLatestPlan(this.$route.query.id).then(res => {
      if (res.data.phases) {
        res.data.phases.forEach(v => {
          v.timeRange = [v.estimatedStartDate, v.estimatedEndDate];
        });
      }
      this.formData = res.data;
      this.formData.projectId = this.$route.query.id;
    });
  },
  mounted() {},
  methods: {
    saveConfirm() {
      projectProcessLatestIsApproved(this.$route.query.id).then(isapp => {
        if (isapp.data) {
          this.save.call(this);
        } else {
          this.$confirm(
            this.$t("messageCommon.latestStepIsUnchecked"),
            this.$t("messageCommon.tips"),
            {
              confirmButtonText: this.$t("button.confirm"),
              cancelButtonText: this.$t("button.cancel"),
              type: "warning"
            }
          ).then(() => {
            this.save.call(this);
          });
        }
      });
    },
    save() {
      this.saveLoding = true;
      let isSucess = this.checkPhaseTimeAll();
      if (!isSucess) {
        this.saveLoding = false;
        return;
      }
      this.formData.phases.forEach(v => {
        v.estimatedStartDate = v.timeRange[0];
        v.estimatedEndDate = v.timeRange[1];
      });
      if (this.isAdd) {
        this.$emit("addSave", this.formData);
        return;
      }
      projectProcessUpdatePlan(this.formData)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: res.message //this.$t("messageCommon.saveSuccess")
            });
            this.$emit("saveCompelete");
            this.cancel();
          }
        })
        .finally(() => {
          this.saveLoding = false;
        });
    },
    /**
     * 返回上一页
     */
    cancel() {
      if (this.isReturn) {
        this.$router.push({
          name: this.$route.query.backToPage
        });
      }
      this.$emit("cancel");
    },

    /**
     * 检查项目阶段时间
     */
    checkPhaseTimeAll() {
      let isSucess = false;
      let phases = this.formData.phases;
      if (!phases || phases.length == 0) {
        isSucess = true;
        return isSucess;
      }

      let stageNameLast = ""; //阶段名称
      let timeRangeSLast = ""; //开始时间
      let timeRangeELast = ""; //结束时间
      for (let i = 0; i < phases.length; i++) {
        let item = phases[i];
        let stageName = item.stageName; //阶段名称
        let timeRange = item.timeRange; //计划时间范围集合
        if (
          !timeRange ||
          timeRange.length < 2 ||
          !timeRange[0] ||
          !timeRange[1]
        ) {
          this.$message({
            type: "warning",
            message: this.$t("messageCommon.itemTipWithName", [
              this.$t("formData.phaseName"),
              stageName,
              this.$t("formData.time"),
              this.$t("messageCommon.beEmpty")
            ])
          });
          return isSucess;
        }

        //后一个阶段开始时间必须大于等于前面的阶段开始时间，后一个阶段结束时间必须大于等于前面的阶段结束时间
        let timeRangeSCur = timeRange[0]; //开始时间
        let timeRangeECur = timeRange[1]; //结束时间
        if (timeRangeSLast && timeRangeSLast > timeRangeSCur) {
          this.$message({
            type: "warning",
            message: this.$t("messageCommon.itemCompareTipWithName2", [
              // this.$t("formData.phaseName"),
              stageName,
              this.$t("messageCommon.startTime"),
              this.$t("messageCommon.greaterThanOrEqualTo"),
              stageNameLast
            ]),
            duration: 5000
          });
          return isSucess;
        }
        if (timeRangeELast && timeRangeELast > timeRangeECur) {
          this.$message({
            type: "warning",
            message: this.$t("messageCommon.itemCompareTipWithName2", [
              // this.$t("formData.phaseName"),
              stageName,
              this.$t("messageCommon.endTime"),
              this.$t("messageCommon.greaterThanOrEqualTo"),
              stageNameLast
            ]),
            duration: 5000
          });
          return isSucess;
        }

        stageNameLast = stageName;
        timeRangeSLast = timeRangeSCur;
        timeRangeELast = timeRangeECur;
      }

      isSucess = true;
      return isSucess;
    },

    /**
     * 计划日期改变事件
     * @param itemCur
     * @param indexCur
     */
    planDateChange(itemCur, indexCur){
      if(!itemCur || !itemCur.timeRange || itemCur.timeRange.length < 2
         || indexCur == undefined || indexCur == null || indexCur === ""
         || !this.formData || !this.formData.phases 
         || indexCur >= this.formData.phases.length - 1){
        return
      }

      let endDateCur = itemCur.timeRange[1]//当前结束日期
      let indexNext = indexCur + 1
      let itemNext = this.formData.phases[indexNext]//下一个阶段对象
      if(itemNext.timeRange && itemNext.timeRange.length == 2
         && itemNext.timeRange[0]) {
        //已经有日期，则跳过
        return
      }
      
      itemNext.defaultValue = endDateCur
      this.datePickerKey++
    }
  }
};
</script>

<style scoped lang="scss">
.projectUpdatePlanView-all-box {
  // background: rgba(255, 255, 255, 1);
  // border-radius: 10px;
  // padding: 30px;
  .top-info {
    margin-left: 100px;
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 24px;
  }
  .down-content-box {
    width: 800px;
    margin: 0 auto;
    padding-right: 235px;

    .line-box {
      line-height: 40px;
      margin-bottom: 30px;
      display: flex;
      justify-content: flex-end;
      .el-date-editor {
        width: 550px;
      }

      .hint {
        width: 275px;
        font-size: 16px;
        color: #999999;
        text-align: center;
        &:first-of-type {
          margin-right: 50px;
        }
      }

      .list-title {
        font-size: 16px;
        margin-right: 40px;
        word-break: keep-all;
        text-overflow: ellipsis;
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .btn-list-box {
    width: 680px;
    margin: 60px auto 0 auto;
    text-align: center;
    .is-plain {
      border-radius: 50px;
    }

    button:first-of-type {
      margin-right: 60px;
    }
  }
}
</style>
